module.exports = __webpack_public_path__ + "img/cu_tit.baf91f87.png";